/**
 * Lizard 多平台跳转弹窗 - JavaScript
 * 处理产品卡片"去选购"按钮点击和弹窗交互
 */

(function() {
  'use strict';

  // 打开弹窗
  function openPlatformPopup(productId) {
    var popup = document.getElementById('lizard-platform-popup-' + productId);
    if (!popup) {
      return;
    }

    // 显示弹窗（移除 aria-hidden 触发 CSS 动画）
    popup.setAttribute('aria-hidden', 'false');

    // 禁止页面滚动
    document.body.style.overflow = 'hidden';

    // 聚焦到关闭按钮
    setTimeout(function() {
      var closeBtn = popup.querySelector('.lizard-platform-close');
      if (closeBtn) closeBtn.focus();
    }, 100);
  }

  // 关闭弹窗
  function closePlatformPopup(popup) {
    if (!popup) return;

    // 隐藏弹窗（aria-hidden 触发 CSS 隐藏）
    popup.setAttribute('aria-hidden', 'true');
    
    // 恢复页面滚动
    document.body.style.overflow = '';
  }

  // 初始化事件监听
  function initPlatformPopup() {
    // 监听"去选购"按钮点击和悬停
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-platform-trigger]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();

        var productId = trigger.getAttribute('data-product-id');
        if (productId) {
          openPlatformPopup(productId);
        }
      }
    });

    // 鼠标悬停自动弹出（仅在有平台链接时）
    document.addEventListener('mouseenter', function(e) {
      var trigger = e.target.closest('[data-platform-trigger]');
      if (trigger && !trigger.classList.contains('is-hovering')) {
        trigger.classList.add('is-hovering');
        var productId = trigger.getAttribute('data-product-id');
        if (productId) {
          openPlatformPopup(productId);
        }
      }
    }, true);

    // 监听关闭按钮和遮罩点击
    document.addEventListener('click', function(e) {
      var closer = e.target.closest('[data-platform-close]');
      if (closer) {
        e.preventDefault();
        var popup = closer.closest('.lizard-platform-popup');
        closePlatformPopup(popup);
      }
    });

    // 监听ESC键关闭
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        var popup = document.querySelector('.lizard-platform-popup[aria-hidden="false"]');
        if (popup) {
          closePlatformPopup(popup);
        }
      }
    });

    // 点击平台链接后关闭弹窗
    document.addEventListener('click', function(e) {
      var platformItem = e.target.closest('.lizard-platform-item');
      if (platformItem) {
        // 延迟关闭，让链接先打开
        setTimeout(function() {
          var popup = platformItem.closest('.lizard-platform-popup');
          if (popup) {
            closePlatformPopup(popup);
          }
        }, 200);
      }
    });
  }

  // DOM加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPlatformPopup);
  } else {
    initPlatformPopup();
  }
})();